import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store';

export interface ContactSupportOptions {
  fullName?: string;
  email?: string;
  title?: string;
  subject?: string;
  message?: string;
  onSuccess?: () => void;
}

interface ContactSupportState {
  showContactSupportModal: boolean;
  options: ContactSupportOptions;
}

const initialState: ContactSupportState = {
  showContactSupportModal: false,
  options: {},
};

const contactSupportSlice = createSlice({
  name: 'contactSupport',
  initialState,
  reducers: {
    openContactSupport(state, action: PayloadAction<ContactSupportOptions>) {
      state.options = action.payload;
      state.showContactSupportModal = true;
    },
    closeContactSupport(state) {
      state.options = {};
      state.showContactSupportModal = false;
    },
  },
});

export const { openContactSupport, closeContactSupport } = contactSupportSlice.actions;

export const selectContactSupportOptions = (state: RootState) =>
  state.contactSupport.options;

export const selectShowContactSupportModal = (state: RootState) =>
  state.contactSupport.showContactSupportModal;

export const reducer = contactSupportSlice.reducer;
